import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-04239edc"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "My-ECharts"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"left-top\" data-v-04239edc></span><span class=\"left-bottom\" data-v-04239edc></span><span class=\"right-top\" data-v-04239edc></span><span class=\"right-bottom\" data-v-04239edc></span><div class=\"top\" data-v-04239edc><div class=\"line\" data-v-04239edc></div><div class=\"title\" data-v-04239edc> 党内统计 </div></div><div class=\"center\" data-v-04239edc><div class=\"name\" data-v-04239edc> 大专及以上学历 党员占比分析 </div><div class=\"name\" data-v-04239edc> 少数民族党员占 比分析 </div><div class=\"name\" data-v-04239edc> 女性党员占比 分析 </div></div>", 6);

var _hoisted_8 = {
  id: "partyMain",
  ref: "eCharts",
  style: {
    "width": "100%",
    "height": "65%",
    "display": "flex",
    "align-items": "end"
  },
  class: "echarts-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_8, null, 512)]);
}